// extracted by mini-css-extract-plugin
export default {"button":"Button_button__UCgkd","flip-in":"Button_flip-in__9uUuk","flip-out":"Button_flip-out__7pplV","scale-in-tr":"Button_scale-in-tr__Iqa-0","slide-in":"Button_slide-in__rDhG9"};